/**
 * Merges direct A/B test variants into `utag.data.optimizelyExp`.
 *
 * @param {Object.<string, string>} directABTests - Experiment-to-variant map.
 * Example: { experiment_key: 'variant_key' }
 * @returns {void}
 */
export function updateOptimizelyExp(directABTests) {
    if (!window.utag?.data) {
        return;
    }

    const optimizelyExp = window.utag.data.optimizelyExp || '';
    const variantsAlreadyPresent = optimizelyExp
        .split('|')
        .map((variant) => variant.trim())
        .filter(Boolean);
    const variantsForTracking = Object.entries(directABTests || {})
        .map(([experimentId, variantName]) => {
            const normalizedExperimentId = experimentId.trim();
            const normalizedVariantName = typeof variantName === 'string' ? variantName.trim() : '';

            return [normalizedExperimentId, normalizedVariantName];
        })
        .filter(([experimentId, variantName]) => experimentId && variantName)
        .map(([experimentId, variantName]) => `${experimentId}:${variantName}`);
    const uniqueVariants = [...new Set([...variantsAlreadyPresent, ...variantsForTracking])];

    window.utag.data.optimizelyExp = uniqueVariants.join('|');
}
